<template>
  <v-app color="black">
    <Navbar :key="`${$route.fullPath}-navbar`"/>
    <v-main :key="resized" :class="main_class">
      <router-view></router-view>
    </v-main>
  </v-app>
</template>

<script>
import Navbar from './components/Navbar'

export default {
  components: { Navbar },
  name: 'App',
  data () {
    return {
      main_class: "mt-10 pa-0",
      resized: Date.now()
    }
  },
  mounted () {
    //window.addEventListener('resize', this.onResize, { passive: true })
  },
  created () {
    this.$vuetify.theme.dark = true;

    if (["xs", "sm"].indexOf(this.$vuetify.breakpoint.name) > -1){
      this.main_class = "mt-16 pa-0"
    }
  },
  methods: {
    onResize() {
      this.resized = Date.now();
    }
  }
}
</script>